import type { LabelSizeId } from "../../types";
import { LABEL_76X51_203DPI } from "./76x51-203dpi";
import { LABEL_100X50_203DPI } from "./100x50-203dpi";
import { LABEL_102X76_203DPI } from "./102x76-203dpi";
import { LABEL_56X25_203DPI } from "./56x25-203dpi";

export { LABEL_76X51_203DPI, LABEL_100X50_203DPI, LABEL_102X76_203DPI, LABEL_56X25_203DPI };

export type LabelSizeSpec =
  | typeof LABEL_76X51_203DPI
  | typeof LABEL_56X25_203DPI
  | typeof LABEL_100X50_203DPI
  | typeof LABEL_102X76_203DPI;

const LABEL_SIZES: Record<LabelSizeId, LabelSizeSpec> = {
  "76x51": LABEL_76X51_203DPI,
  "56x25": LABEL_56X25_203DPI,
  "100x50": LABEL_100X50_203DPI,
  "102x76": LABEL_102X76_203DPI,
};

/** Display order for every size dropdown. */
export const ALL_LABEL_SIZES: readonly LabelSizeId[] = ["76x51", "56x25", "100x50", "102x76"] as const;

/** Default physical size for label templates (also the fallback layout). */
export const DEFAULT_LABEL_SIZE: LabelSizeId = "76x51";

export const SPARE_PART_LABEL_SIZE: LabelSizeId = "76x51";

export function getLabelSize(size: LabelSizeId = DEFAULT_LABEL_SIZE): LabelSizeSpec {
  return LABEL_SIZES[size] ?? LABEL_SIZES[DEFAULT_LABEL_SIZE];
}

/** Human-readable size label (e.g. "76 × 51 mm"). */
export function labelSizeLabel(size: LabelSizeId): string {
  return LABEL_SIZES[size]?.label ?? size;
}

/** Recommended use for a size (e.g. "Small parts"). */
export function labelSizeRecommendedUse(size: LabelSizeId): string {
  return LABEL_SIZES[size]?.recommendedUse ?? "";
}

/** Dropdown text: "76 × 51 mm — Default · all labels". */
export function labelSizeOptionLabel(size: LabelSizeId): string {
  const use = labelSizeRecommendedUse(size);
  return use ? `${labelSizeLabel(size)} — ${use}` : labelSizeLabel(size);
}
